module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.2952/js/img/Service.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!/usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/img/Service.svg
// module id = 697
// module chunks = 5 6